import { GenericCheckboxCategoryFilter, GenericCheckboxFilter } from '../../../shared/filters/generic-checkbox-category-filter/generic-checkbox-category-filter.model';

export class GenericCategoryFilter extends GenericCheckboxCategoryFilter {
  name: string;
  filters: GenericCheckboxFilter[];

  get showFilter() {
    return (this.filters && this.filters.length > 1);
  }
}
